import React, { useState } from 'react';
import '../HomePage.css';
import SelfPacedLearning from './SelfPacedLearning';
import { useNavigate } from 'react-router-dom';

function AnimatedCards() {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    return (
        <div className="unique-cards-container">
            <div className="unique-card find-my-career-card">
                <h2>Find Your Dream Career</h2>
                <p>Discover career paths that align with your interests and skills.</p>
                <button className="unique-card-button" onClick={openModal}>Explore Now</button>
            </div>

            <SelfPacedLearning isOpen={isModalOpen} closeModel={closeModal} />
            <div className="unique-card find-coach-card">
                <h2>Find Your Career Coach</h2>
                <p>Get personalized guidance to achieve your professional goals.</p>
                <button className="unique-card-button" onClick={() => navigate('/career-coaches')}>Find a Coach</button>
            </div>

            <div className="unique-card connect-professional-card">
                <h2>Connect with an Industry Professional</h2>
                <p>Network with experts to gain valuable insights and mentorship.</p>
                <button className="unique-card-button" onClick={() => navigate('/professionals')}>Connect Now</button>
            </div>
        </div>
    );
}

export default AnimatedCards;
